'use client'
import Script from 'next/script'
import { getAppConfig } from '@/config/config'
import { useConsentReady } from '@/hooks/useConsentReady'
import { useContext, useEffect, useState } from 'react'
import { ConsentContext } from '@/context/ConsentContext'

const config = getAppConfig()
const basePath = config.basePath

export const AdDefend = () => {
  const consentReady = useConsentReady()
  const consentContext = useContext(ConsentContext)
  const [loadScript, setLoadScript] = useState<boolean>(false)

  useEffect(() => {
    setLoadScript(consentReady && !!consentContext.userConsents?.addefend)
  }, [consentReady])

  return (
    loadScript && (
      <Script
        src={`${basePath}/adDefend.js`}
        onLoad={() => console.log('[AdDefend] AdDefend script loaded')}
        onError={(error) => console.error('[AdDefend] Error while loading AdDefend script ', error)}
      />
    )
  )
}
